export class VaultUserCache {
    constructor() {
        this.cache = new Map();
    }
    get(sharedVaultUuid) {
        return this.cache.get(sharedVaultUuid);
    }
    set(sharedVaultUuid, users) {
        this.cache.set(sharedVaultUuid, users);
    }
}
